import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { InfoPageCanvas } from '@/features/app-shell/canvases/info-page-canvas'

export const Route = createFileRoute('/app/terms')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppTermsPage,
})

function AppTermsPage() {
  return (
    <AppShell activePath="/app/terms">
      <InfoPageCanvas kind="terms" />
    </AppShell>
  )
}
